import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DataService } from "../../../../services/data.service";
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-interceptor-data',
  templateUrl: './interceptor-data.component.html',
  styleUrls: ['./interceptor-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InterceptorDataComponent implements OnInit {

  keys?: [];
  endpoint: string | undefined;
  interceptorData: any[] = [];
  legends?: any;

  constructor(
    private localService: LocalService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

    let model = this.localService.getAllKeys();
    if (model) this.setInterceptorData(model)

    this.localService.currentKeysData$.subscribe(model => {
      if (model) this.setInterceptorData(model)
    })
  }

  setInterceptorData(model: any) {
    this.interceptorData = []; let i;
    this.keys?.forEach((obj: any, index) => {
      let val = model[obj.value];

      if (this.legends[obj.value]) {
        if (this.legends[obj.value]['endpoint'] && model[obj.value]) {
          this.interceptorData[index] = {} // per preservare l'ordine delle keys
          this.loadData(this.legends[obj.value]['endpoint'] + "/" + model[obj.value], obj, index)
        } else {
          val = this.legends[obj.value][model[obj.value]];
          this.interceptorData[index] = { "label": obj.label, "value": val };
        }
      } else {
        this.interceptorData[index] = { "label": obj.label, "value": val };
      }

    })
    this.cdr.markForCheck();
  }

  loadData(endpoint: string, obj: any, index: number) {
    this.dataService.getData(endpoint).subscribe(model => {
      this.interceptorData[index] = { "label": obj.label, "value": model.title }
      this.cdr.markForCheck();
    })
  }

}
